import { render } from "./OrdersComponent.vue?vue&type=template&id=76b59db0&scoped=true"
import script from "./OrdersComponent.vue?vue&type=script&lang=js"
export * from "./OrdersComponent.vue?vue&type=script&lang=js"

import "./OrdersComponent.vue?vue&type=style&index=0&id=76b59db0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-76b59db0"

export default script